import {
    isArrayObjectControl,
    isBooleanControl,
    isEnumControl,
    isNumberControl,
    isObjectArrayControl,
    isPrimitiveArrayControl,
    isStringControl,
    or,
    rankWith,
    uiTypeIs
} from '@jsonforms/core'
import DInputControl from '~@/Components/JSONForms/Renderers/DInputControl.vue'
import ArrayListRenderer from '~@/Components/JSONForms/Renderers/ArrayListRenderer.vue'

export const DInputControlRenderer = {
    tester: rankWith(10, or(
        isStringControl,
        isBooleanControl,
        isNumberControl,
        isEnumControl
    )),
    renderer: DInputControl
}

export const DArrayRenderer = {
    tester: rankWith(100, or(
        isObjectArrayControl,
        isArrayObjectControl,
        isPrimitiveArrayControl,
        uiTypeIs('ListWithDetail')
    )),
    renderer: ArrayListRenderer,
}
